var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafeNutrify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 498,
    height: 497,
    viewBox: "0 0 498 497",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 120.8C25.6 120.8 16.8 102.4 10.4 89.6C8 85.6 4.8 78.4 3.2 77.6C-2.38419e-07 76 -0.8 72 0.8 69.6C2.4 66.4 5.6 65.6 8.8 67.2H11.2C14.4 67.2 18.4 66.4 22.4 65.6C28 64 35.2 63.2 41.6 63.2C52 63.2 60 66.4 65.6 72C72.8 79.2 76 89.6 75.2 104.8C75.2 106.4 74.4 108.8 72.8 109.6C62.4 116.8 53.6 120.8 44.8 120.8ZM18.4 78.4C19.2 80 20 82.4 21.6 84C28.8 98.4 34.4 108.8 45.6 108.8C50.4 108.8 56.8 106.4 64 101.6C64 92 61.6 84.8 57.6 80.8C54.4 77.6 49.6 76 42.4 76C36.8 76 30.4 76.8 24.8 77.6C22.4 77.6 20 77.6 18.4 78.4Z",
    fill: "url(#paint0_linear_1744_1285)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4 111.2C66.4 111.2 52 107.2 40 98.4C37.6 96.8 36.8 92.8 38.4 90.4C40 88 44 87.2 46.4 88.8C59.2 98.4 76.8 100.8 96.8 97.6C100 96.8 103.2 99.2 104 102.4C104.8 105.6 102.4 108.8 99.2 109.6C93.6 110.4 87.2 111.2 82.4 111.2Z",
    fill: "url(#paint1_linear_1744_1285)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88 82.4C87.2 82.4 85.6 82.4 84.8 81.6C71.2 72.8 64 63.2 63.2 52.8C61.6 37.6 73.6 24.8 83.2 16C86.4 12.8 91.2 8 92 5.6C92 2.4 95.2 0 98.4 0C101.6 0.8 104 3.2 103.2 6.4C103.2 8 106.4 15.2 108.8 19.2C115.2 31.2 123.2 45.6 118.4 60C114.4 69.6 105.6 76.8 90.4 81.6C89.6 82.4 88.8 82.4 88 82.4ZM96 19.2C94.4 20.8 93.6 21.6 92 23.2C84 31.2 74.4 40.8 75.2 50.4C76 56.8 80.8 62.4 88.8 68.8C98.4 64.8 104.8 60.8 107.2 55.2C110.4 46.4 104 34.4 98.4 24.8C97.6 23.2 96.8 21.6 96 19.2Z",
    fill: "url(#paint2_linear_1744_1285)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4 109.6C96 109.6 94.4 108.8 92.8 106.4C81.6 85.6 78.4 65.6 83.2 47.2C84 44 87.2 42.4 90.4 43.2C93.6 44 95.2 47.2 94.4 50.4C90.4 65.6 93.6 83.2 103.2 101.6C104.8 104.8 104 108 100.8 109.6C100 109.6 99.2 109.6 98.4 109.6Z",
    fill: "url(#paint3_linear_1744_1285)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M392.8 75.2H391.2C389.6 75.2 387.2 74.4 386.4 72.8C376.8 60 373.6 48.8 376 38.4C380 24 395.2 16 407.2 10.4C411.2 8 418.4 4.8 419.2 3.2C420.8 -2.38419e-07 424 -0.8 427.2 0.8C430.4 2.4 431.2 5.6 429.6 8.8C428.8 10.4 429.6 17.6 430.4 22.4C432.8 36 435.2 52 425.6 64C419.2 72 408 75.2 392.8 75.2ZM417.6 18.4C416 19.2 413.6 20 412 21.6C402.4 26.4 389.6 32.8 388 41.6C386.4 47.2 388.8 55.2 394.4 64C404.8 64 412.8 61.6 416 56.8C422.4 49.6 420 36 418.4 24.8C418.4 22.4 418.4 20 417.6 18.4Z",
    fill: "url(#paint4_linear_1744_1285)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M392 104C388.8 104 386.4 101.6 386.4 99.2C382.4 75.2 386.4 55.2 397.6 40C399.2 37.6 403.2 36.8 405.6 38.4C408 40 408.8 44 407.2 46.4C397.6 59.2 395.2 76.8 398.4 96.8C399.2 100 396.8 103.2 393.6 104C392.8 104 392.8 104 392 104Z",
    fill: "url(#paint5_linear_1744_1285)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M446.4 120C432 120 420.8 109.6 414.4 89.6C413.6 88 414.4 85.6 415.2 84.8C424.8 70.4 435.2 63.2 446.4 63.2C460 63.2 471.2 74.4 480.8 82.4C484 85.6 489.6 91.2 492 91.2C495.2 91.2 497.6 94.4 497.6 97.6C497.6 100.8 494.4 103.2 491.2 103.2C488.8 103.2 483.2 106.4 478.4 108.8C468.8 114.4 457.6 120 446.4 120ZM427.2 88.8C433.6 105.6 441.6 108 446.4 108C454.4 108 463.2 103.2 471.2 98.4C472.8 97.6 475.2 96 476.8 95.2C475.2 93.6 473.6 92 472 90.4C464.8 83.2 455.2 74.4 446.4 74.4C440 75.2 433.6 80 427.2 88.8Z",
    fill: "url(#paint6_linear_1744_1285)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M392 104C389.6 104 388 103.2 386.4 100.8C384.8 97.6 385.6 94.4 388.8 92.8C409.6 81.6 429.6 78.4 448 83.2C451.2 84 452.8 87.2 452 90.4C451.2 93.6 448 95.2 444.8 94.4C429.6 90.4 412 93.6 393.6 103.2C394.4 104 393.6 104 392 104Z",
    fill: "url(#paint7_linear_1744_1285)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M455.2 432.8C444.8 432.8 436.8 429.6 431.2 424C424 416.8 420.8 406.4 421.6 391.2C421.6 389.6 422.4 387.2 424 386.4C434.4 379.2 443.2 375.2 452 375.2C470.4 375.2 480 392.8 486.4 406.4C488.8 411.2 492 416.8 493.6 418.4C496 419.2 497.6 421.6 497.6 424C497.6 428 494.4 430.4 490.4 429.6C489.6 429.6 488.8 429.6 488.8 428.8C488.8 428.8 481.6 428.8 475.2 429.6C468.8 432 461.6 432.8 455.2 432.8ZM433.6 394.4C433.6 404 436 411.2 440 415.2C443.2 418.4 448 420 455.2 420C460.8 420 467.2 419.2 472.8 418.4C474.4 418.4 476.8 417.6 478.4 417.6C477.6 416 476 413.6 475.2 411.2C469.6 400 463.2 387.2 451.2 387.2C446.4 387.2 440 389.6 433.6 394.4Z",
    fill: "url(#paint8_linear_1744_1285)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M452.8 408C452 408 450.4 408 449.6 407.2C436.8 397.6 419.2 395.2 399.2 398.4C396 399.2 392.8 396.8 392 393.6C391.2 390.4 393.6 387.2 396.8 386.4C420.8 382.4 440.8 386.4 456 397.6C458.4 399.2 459.2 403.2 457.6 405.6C456.8 407.2 454.4 408 452.8 408Z",
    fill: "url(#paint9_linear_1744_1285)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M398.4 496.8C394.4 496.8 392 493.6 392.8 490.4C392.8 488.8 389.6 481.6 387.2 477.6C380.8 465.6 372.8 451.2 377.6 436.8C381.6 427.2 390.4 420 405.6 415.2C407.2 414.4 409.6 415.2 410.4 416C424 424.8 431.2 434.4 432 444C433.6 459.2 421.6 471.2 412.8 480.8C409.6 484 404 489.6 404 492C404 494.4 401.6 496.8 398.4 496.8ZM407.2 427.2C397.6 431.2 391.2 435.2 388.8 440.8C385.6 449.6 392 461.6 397.6 471.2C398.4 472.8 400 475.2 400.8 476.8L405.6 472C413.6 464 422.4 454.4 421.6 444.8C420 439.2 415.2 432.8 407.2 427.2Z",
    fill: "url(#paint10_linear_1744_1285)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M407.2 453.6C406.4 453.6 406.4 453.6 405.6 453.6C402.4 452.8 400.8 449.6 401.6 446.4C405.6 431.2 402.4 413.6 392.8 395.2C391.2 392 392 388.8 395.2 387.2C398.4 385.6 401.6 386.4 403.2 389.6C414.4 410.4 417.6 430.4 412.8 448.8C412 451.2 409.6 453.6 407.2 453.6Z",
    fill: "url(#paint11_linear_1744_1285)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72 496.8C68.8 496.8 65.6 494.4 65.6 490.4C65.6 489.6 65.6 488.8 66.4 488C67.2 486.4 66.4 479.2 65.6 474.4C63.2 460.8 60.8 444.8 70.4 432.8C76.8 424.8 88 420.8 103.2 420.8H104.8C106.4 420.8 108.8 421.6 109.6 423.2C119.2 436 122.4 447.2 120 456.8C116.8 471.2 101.6 479.2 89.6 484.8C84.8 487.2 78.4 490.4 77.6 492.8C76 495.2 74.4 496.8 72 496.8ZM101.6 433.6C91.2 433.6 83.2 436 80 440.8C73.6 448 76 461.6 77.6 472.8C77.6 475.2 78.4 476.8 78.4 478.4C80 477.6 82.4 476 84.8 475.2C95.2 470.4 106.4 464 108.8 455.2C109.6 448.8 107.2 441.6 101.6 433.6Z",
    fill: "url(#paint12_linear_1744_1285)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6 458.4C92.8 458.4 91.2 458.4 90.4 457.6C88 456 87.2 452 88.8 449.6C98.4 436.8 100.8 419.2 97.6 399.2C96.8 396 99.2 392.8 102.4 392C105.6 391.2 108.8 393.6 109.6 396.8C113.6 420.8 109.6 440.8 98.4 456C97.6 457.6 95.2 458.4 93.6 458.4Z",
    fill: "url(#paint13_linear_1744_1285)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6 432.8C35.2 432.8 24 421.6 15.2 412.8C12 409.6 7.2 404.8 4.8 404C2.4 404 0 400.8 0 397.6C0.8 394.4 3.2 392 6.4 392.8C8.8 392.8 14.4 389.6 19.2 387.2C28 381.6 39.2 376 50.4 376C64.8 376 76 386.4 82.4 406.4C83.2 408 82.4 410.4 81.6 412C72 425.6 61.6 432.8 49.6 432.8ZM19.2 400C20.8 401.6 21.6 402.4 23.2 404C30.4 411.2 40 420.8 49.6 420.8C56 420.8 63.2 416 69.6 406.4C63.2 389.6 55.2 387.2 50.4 387.2C42.4 387.2 33.6 392 25.6 396.8C23.2 398.4 21.6 399.2 19.2 400Z",
    fill: "url(#paint14_linear_1744_1285)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64 415.2C58.4 415.2 52.8 414.4 47.2 412.8C44 412 42.4 408.8 43.2 405.6C44 402.4 47.2 400.8 50.4 401.6C65.6 405.6 83.2 402.4 101.6 392.8C104.8 391.2 108 392 109.6 395.2C111.2 398.4 110.4 401.6 107.2 403.2C92 411.2 77.6 415.2 64 415.2Z",
    fill: "url(#paint15_linear_1744_1285)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M312 348.8C309.6 348.8 307.2 347.2 306.4 344.8C306.4 344 305.6 343.2 304 341.6C297.6 334.4 288 329.6 274.4 327.2C272 326.4 269.6 326.4 267.2 325.6C256.8 324 246.4 321.6 236.8 316.8C236 316 234.4 315.2 234.4 314.4C230.4 307.2 230.4 297.6 233.6 288.8C237.6 279.2 244.8 272 253.6 269.6C259.2 268 265.6 268 271.2 268H280.8C286.4 267.2 292.8 264 292.8 259.2C292.8 255.2 289.6 252.8 286.4 251.2C282.4 249.6 276.8 249.6 271.2 249.6C268.8 249.6 267.2 248.8 266.4 246.4C263.2 240.8 262.4 234.4 265.6 228C268.8 220 276.8 213.6 285.6 212C298.4 209.6 311.2 214.4 322.4 219.2L324.8 220C334.4 224 343.2 228 352 226.4H352.8C354.4 225.6 356.8 225.6 357.6 224.8C360 223.2 364 224 365.6 226.4C367.2 228.8 366.4 232.8 364 234.4C361.6 236 358.4 236.8 356 237.6L354.4 238.4C340.8 240.8 330.4 236 319.2 232L316 230.4C306.4 226.4 296 221.6 286.4 224C281.6 224.8 277.6 228.8 275.2 232.8C274.4 234.4 274.4 236 274.4 237.6C280 237.6 285.6 238.4 290.4 240C299.2 244 304 250.4 304 258.4C304 270.4 292 278.4 280.8 279.2C277.6 279.2 273.6 279.2 270.4 279.2C265.6 279.2 260 279.2 256 280C251.2 281.6 246.4 286.4 244 292C242.4 296.8 241.6 301.6 243.2 305.6C250.4 308.8 260 310.4 268 312C270.4 312.8 272.8 312.8 275.2 313.6C291.2 316.8 304 323.2 311.2 332C312.8 333.6 315.2 336 316 339.2C316.8 342.4 315.2 345.6 312 346.4C313.6 348.8 312.8 348.8 312 348.8Z",
    fill: "url(#paint16_linear_1744_1285)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M195.2 225.6C186.4 225.6 178.4 222.4 172 216C165.6 209.6 161.6 199.2 161.6 184C161.6 180.8 161.6 178.4 161.6 175.2C161.6 172.8 161.6 169.6 161.6 167.2C161.6 164 164 160.8 168 160.8C172 160.8 174.4 163.2 174.4 167.2V184C174.4 195.2 176.8 203.2 180.8 208C185.6 213.6 193.6 215.2 200.8 213.6C208 212.8 214.4 207.2 219.2 200C223.2 194.4 224.8 187.2 227.2 180C231.2 168 235.2 156 245.6 148.8C252 144.8 259.2 142.4 265.6 140.8C271.2 139.2 276 137.6 280 135.2C283.2 133.6 286.4 134.4 288 136.8C289.6 139.2 288.8 143.2 286.4 144.8C280.8 148 274.4 149.6 268.8 151.2C262.4 152.8 256.8 154.4 252.8 157.6C245.6 163.2 242.4 172.8 239.2 183.2C236.8 190.4 234.4 198.4 229.6 205.6C223.2 216 213.6 223.2 204 224.8C200.8 224.8 197.6 225.6 195.2 225.6Z",
    fill: "url(#paint17_linear_1744_1285)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M175.2 341.6C173.6 341.6 172 340.8 170.4 339.2C168 336.8 168.8 332.8 171.2 330.4C175.2 327.2 177.6 322.4 177.6 317.6C177.6 315.2 177.6 313.6 176.8 311.2C176 304.8 175.2 296 181.6 289.6C185.6 285.6 191.2 284 196.8 283.2C201.6 281.6 201.6 280 201.6 280C201.6 278.4 198.4 276.8 196 276C195.2 276 194.4 276 193.6 276C188.8 276 183.2 276 177.6 273.6C173.6 272 171.2 269.6 168.8 267.2C167.2 265.6 165.6 264 164 263.2C160 260.8 153.6 262.4 148.8 264C147.2 264.8 145.6 265.6 144 266.4C142.4 267.2 140.8 268 139.2 268.8C136 270.4 132.8 268.8 131.2 266.4C129.6 263.2 131.2 260 133.6 258.4C135.2 257.6 136.8 256.8 138.4 256C140 255.2 142.4 253.6 144 252.8C151.2 248.8 162.4 247.2 170.4 252C172.8 253.6 174.4 255.2 176.8 256.8C179.2 258.4 180.8 260.8 183.2 261.6C186.4 262.4 189.6 262.4 194.4 262.4H198.4C207.2 264 215.2 270.4 214.4 280C212.8 288 204.8 291.2 201.6 292.8C200.8 292.8 200.8 292.8 200 292.8C196 293.6 192.8 294.4 191.2 296C188.8 298.4 189.6 301.6 189.6 308C189.6 310.4 190.4 313.6 190.4 316C190.4 324 186.4 332 180 337.6C177.6 341.6 176.8 341.6 175.2 341.6Z",
    fill: "url(#paint18_linear_1744_1285)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M248 368C181.6 368 128 314.4 128 248C128 181.6 181.6 128 248 128C314.4 128 368 181.6 368 248C368 314.4 314.4 368 248 368ZM248 140C188.8 140 140 188.8 140 248C140 307.2 188.8 356 248 356C307.2 356 356 307.2 356 248C356 188.8 307.2 140 248 140Z",
    fill: "url(#paint19_linear_1744_1285)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M230.4 441.6H228.8C220 441.6 212 435.2 211.2 426.4C210.4 417.6 216 408.8 224.8 406.4C228 405.6 231.2 407.2 232 410.4C232.8 413.6 231.2 416.8 228 417.6C224.8 418.4 222.4 420.8 223.2 424C223.2 427.2 226.4 428.8 228.8 428.8H229.6L257.6 424.8C260.8 424 264 426.4 264 429.6C264.8 432.8 262.4 436 259.2 436L230.4 440V441.6Z",
    fill: "url(#paint20_linear_1744_1285)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M320 481.6C319.2 481.6 318.4 481.6 316.8 480.8L295.2 468.8C289.6 465.6 282.4 464 276 464.8L245.6 468C244 468 242.4 468.8 240 468.8C232 468.8 224 465.6 218.4 460.8L145.6 392C140.8 388 140 382.4 140 378.4C140 373.6 141.6 369.6 144.8 366.4C149.6 360 161.6 358.4 169.6 364L229.6 407.2L281.6 400C290.4 399.2 298.4 400.8 304.8 405.6L324.8 421.6C326.4 422.4 327.2 424.8 327.2 426.4L326.4 476C326.4 478.4 325.6 480 323.2 480.8C322.4 480.8 321.6 481.6 320 481.6ZM280 452.8C287.2 452.8 295.2 454.4 301.6 458.4L314.4 465.6L315.2 428.8L297.6 415.2C293.6 412.8 288 411.2 283.2 412L229.6 420C228 420 225.6 420 224.8 419.2L162.4 375.2C160 373.6 155.2 373.6 153.6 376C152 376 152 376.8 152 378.4C152 381.6 152.8 382.4 153.6 383.2L228 452C232.8 456 239.2 457.6 245.6 456.8L276.8 453.6C276.8 452.8 278.4 452.8 280 452.8Z",
    fill: "url(#paint21_linear_1744_1285)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M352 496H329.6C320.8 496 314.4 489.6 314.4 480.8V418.4C314.4 410.4 321.6 403.2 329.6 403.2H352C355.2 403.2 358.4 405.6 358.4 409.6C358.4 413.6 356 416 352 416H329.6C327.2 416 326.4 417.6 326.4 419.2V481.6C326.4 484 328 484.8 329.6 484.8H352C355.2 484.8 358.4 487.2 358.4 491.2C358.4 495.2 355.2 496 352 496Z",
    fill: "url(#paint22_linear_1744_1285)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M269.6 89.6C267.2 89.6 264.8 88 264 84.8C263.2 81.6 264.8 78.4 268 77.6C271.2 76.8 273.6 74.4 272.8 71.2C272.8 68 269.6 66.4 267.2 66.4H266.4L238.4 70.4C235.2 71.2 232 68.8 232 65.6C231.2 62.4 233.6 59.2 236.8 59.2L265.6 55.2H268C276.8 55.2 284.8 61.6 285.6 70.4C286.4 79.2 280.8 88 272 90.4C270.4 89.6 270.4 89.6 269.6 89.6Z",
    fill: "url(#paint23_linear_1744_1285)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M338.4 135.2C334.4 135.2 330.4 134.4 327.2 131.2L267.2 88L215.2 95.2C207.2 96 198.4 94.4 192 89.6L172 73.6C170.4 72.8 169.6 70.4 169.6 68.8V20.8C169.6 17.6 172.8 14.4 176 15.2C176.8 15.2 178.4 15.2 179.2 16L200.8 28C206.4 31.2 213.6 32.8 220 32L250.4 28.8C259.2 27.2 269.6 29.6 277.6 36.8L351.2 104.8C356 108.8 356.8 114.4 356.8 118.4C356.8 123.2 355.2 127.2 352 130.4C348 133.6 343.2 135.2 338.4 135.2ZM267.2 76.8C268.8 76.8 270.4 76.8 271.2 77.6L333.6 121.6C336.8 124 340.8 123.2 342.4 120.8C344 120 344 119.2 344 117.6C344 114.4 343.2 113.6 342.4 112.8L268 44C264 40.8 257.6 38.4 251.2 40L220 43.2C211.2 44 201.6 42.4 193.6 37.6L180 30.4V67.2L197.6 80.8C201.6 83.2 207.2 84.8 212 84L265.6 76C267.2 76.8 267.2 76.8 267.2 76.8Z",
    fill: "url(#paint24_linear_1744_1285)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M166.4 92.8H144C140.8 92.8 137.6 90.4 137.6 86.4C137.6 82.4 140 80 144 80H166.4C168.8 80 169.6 78.4 169.6 76.8V15.2C169.6 12.8 168 12 166.4 12H144C140.8 12 137.6 9.6 137.6 5.6C137.6 1.6 140.8 0 144 0H166.4C175.2 0 181.6 6.4 181.6 15.2V77.6C181.6 85.6 175.2 92.8 166.4 92.8Z",
    fill: "url(#paint25_linear_1744_1285)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M64 264.8C60.8 264.8 58.4 262.4 58.4 260L54.4 231.2V228.8C54.4 220 60.8 212 69.6 211.2C78.4 210.4 87.2 216 89.6 224.8C90.4 228 88.8 231.2 85.6 232C82.4 232.8 79.2 231.2 78.4 228C77.6 224.8 75.2 223.2 72 223.2C68.8 223.2 67.2 226.4 67.2 228.8V229.6L71.2 257.6C72 260.8 69.6 264 66.4 264C64.8 264.8 64.8 264.8 64 264.8Z",
    fill: "url(#paint26_linear_1744_1285)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4 327.2L20.8 326.4C18.4 326.4 16.8 325.6 16 323.2C15.2 321.6 15.2 319.2 16 317.6L28 296C31.2 290.4 32.8 283.2 32 276.8L28.8 246.4C27.2 237.6 29.6 227.2 36.8 219.2L104.8 145.6C108.8 140.8 114.4 140 118.4 140C123.2 140 127.2 141.6 130.4 144.8C136.8 150.4 138.4 161.6 132.8 169.6L89.6 229.6L96.8 281.6C97.6 289.6 96 298.4 91.2 304.8L75.2 324.8C73.6 326.4 72 327.2 70.4 327.2ZM30.4 314.4L67.2 315.2L80.8 297.6C83.2 293.6 84.8 288 84 283.2L76 229.6V228.8C76 227.2 76 225.6 76.8 224.8L120.8 162.4C123.2 159.2 122.4 155.2 120 153.6C120 152 119.2 152 117.6 152C114.4 152 113.6 152.8 112.8 153.6L44 228C40.8 232 38.4 238.4 40 244.8L43.2 276C44 284.8 42.4 294.4 37.6 302.4L30.4 314.4Z",
    fill: "url(#paint27_linear_1744_1285)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4 357.6C83.2 357.6 80 355.2 80 351.2V328.8C80 326.4 78.4 325.6 76.8 325.6H15.2C12.8 325.6 12 327.2 12 328.8V352C12 355.2 9.6 358.4 5.6 358.4C1.6 358.4 0 355.2 0 352V329.6C0 320.8 6.4 314.4 15.2 314.4H77.6C85.6 314.4 92.8 321.6 92.8 329.6V352C92.8 355.2 89.6 357.6 86.4 357.6Z",
    fill: "url(#paint28_linear_1744_1285)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M424 284.8C416 284.8 408.8 279.2 406.4 271.2C405.6 268 407.2 264.8 410.4 264C413.6 263.2 416.8 264.8 417.6 268C418.4 271.2 420.8 272.8 424 272.8C427.2 272.8 428.8 269.6 428.8 267.2V266.4L424.8 238.4C424 235.2 426.4 232 429.6 232C432.8 231.2 436 233.6 436 236.8L440 265.6V268C440 276.8 433.6 284.8 424.8 285.6C425.6 284.8 424.8 284.8 424 284.8Z",
    fill: "url(#paint29_linear_1744_1285)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M378.4 356C373.6 356 369.6 354.4 366.4 351.2C360 345.6 358.4 334.4 364 326.4L407.2 266.4L400 214.4C399.2 206.4 400.8 197.6 405.6 191.2L421.6 171.2C422.4 169.6 424.8 168.8 426.4 168.8H476C479.2 168.8 482.4 171.2 482.4 175.2C482.4 176 482.4 177.6 481.6 178.4L469.6 200C466.4 205.6 464.8 212.8 465.6 219.2L468.8 249.6C470.4 258.4 468 268.8 460.8 276.8L392 350.4C388 356 382.4 356 378.4 356ZM428.8 180.8L415.2 198.4C412.8 202.4 411.2 208 412 212.8L420 266.4V267.2C420 268.8 420 270.4 419.2 271.2L375.2 333.6C372.8 336.8 373.6 340.8 376 342.4C376 344 376.8 344 378.4 344C381.6 344 382.4 343.2 383.2 342.4L452 268C456 263.2 457.6 256.8 456.8 250.4L453.6 219.2C452.8 210.4 454.4 200.8 459.2 192.8L466.4 179.2H428.8V180.8Z",
    fill: "url(#paint30_linear_1744_1285)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M480.8 181.6H418.4C410.4 181.6 403.2 174.4 403.2 166.4V144C403.2 140.8 405.6 137.6 409.6 137.6C413.6 137.6 416 140 416 144V166.4C416 168.8 417.6 169.6 419.2 169.6H481.6C484 169.6 484.8 168 484.8 166.4V144C484.8 140.8 487.2 137.6 491.2 137.6C495.2 137.6 496 140.8 496 144V166.4C496 175.2 489.6 181.6 480.8 181.6Z",
    fill: "url(#paint31_linear_1744_1285)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1744_1285",
    x1: 501.477,
    y1: 108.594,
    x2: -153.298,
    y2: 162.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeNutrify);
export default __webpack_public_path__ + "static/media/safe-nutrify.7662fd13efe9e784550bf21ecca88e2b.svg";
export { ForwardRef as ReactComponent };